import React, { useState } from "react";
import { FaArrowLeft, FaArrowRight, FaStar } from "react-icons/fa";
import reviewer1 from "../../imgs/reviews/reviewer1.jpg";
import reviewer2 from "../../imgs/reviews/reviewer2.jpg";
import reviewer3 from "../../imgs/reviews/reviewer3.jpg";
import "./ProjectsSection.css";

const reviews = [
  {
    name: "David Thompson",
    role: "College Student",
    image: require("../../imgs/reviews/reviewer1.jpg"),
    rating: 4.5,
    reviewText:
      "This restaurant has become my go-to spot for great meals with minimal fuss. Their foods are consistently tasty, and the serving sizes are ample.",
  },
  {
    name: "Maria Lopez",
    role: "Food Blogger",
    image: require("../../imgs/reviews/reviewer2.jpg"),
    rating: 5,
    reviewText:
      "Absolutely love the variety on the menu! Every visit feels like a new culinary experience. The service is excellent and the ambiance is perfect.",
  },
  {
    name: "Kevin Johnson",
    role: "Entrepreneur",
    image: require("../../imgs/reviews/reviewer3.jpg"),
    rating: 4.2,
    reviewText:
      "Great coffee, friendly staff, and cozy vibes. A perfect place to work or catch up with friends. Highly recommend the cappuccino and pancakes!",
  },
];

const ProjectsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentReview = reviews[currentIndex];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
  };

  return (
    <>
    <section className="testimonials-section">
      <div className="testimonial-left">
        <h2>What Our Customers Says About Us</h2>
        <div className="reviewer-preview">
          <div className="avatars">
            <img src={reviewer1} alt="reviewer 1" />
            <img src={reviewer2} alt="reviewer 2" />
            <img src={reviewer3} alt="reviewer 3" />
          </div>
          <div className="count">15k+</div>
        </div>
      </div>

      <div className="testimonial-card">
        <div className="header">
          <div className="info">
            <img src={currentReview.image} alt={currentReview.name} />
            <div>
              <div className="name">{currentReview.name}</div>
              <div className="role">{currentReview.role}</div>
            </div>
          </div>
          <div className="stars">
            {Array.from({ length: Math.floor(currentReview.rating) }).map((_, i) => (
              <FaStar key={i} />
            ))}
            {currentReview.rating % 1 !== 0 && <FaStar style={{ opacity: 0.5 }} />}
            ({currentReview.rating})
          </div>
        </div>

        <p className="text">{currentReview.reviewText}</p>

        <div className="arrows">
          <button onClick={handlePrev}><FaArrowLeft /></button>
          <button onClick={handleNext}><FaArrowRight /></button>
        </div>
      </div>
    </section>
    </>
  );
};

export default ProjectsSection;